"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFSContextMenu = void 0;
const react_1 = require("react");
const FileSystemContext_1 = require("../FileSystemContext");
const useSelectItems_1 = require("./useSelectItems");
function useFSContextMenu() {
    const ctx = (0, react_1.useContext)(FileSystemContext_1.FileSystemContext);
    const { props: { getContextMenuOptions }, setState, state } = ctx;
    const { isSelected, selectedItems } = (0, useSelectItems_1.useSelectItems)();
    const handleContextMenu = (0, react_1.useCallback)((item, event) => {
        if (getContextMenuOptions === undefined || getContextMenuOptions === null)
            return;
        event.stopPropagation();
        event.persist();
        event.preventDefault();
        setState(state => {
            let selectedItems = state.selectedItems;
            if (item && !isSelected(item)) {
                selectedItems = [item];
            }
            const options = getContextMenuOptions(selectedItems, ctx);
            return Object.assign(Object.assign({}, state), { selectedItems, contextMenu: {
                    options,
                    event
                } });
        });
    }, [getContextMenuOptions, selectedItems, ctx]);
    const handleContextMenuClose = (0, react_1.useCallback)(() => {
        setState(state => (Object.assign(Object.assign({}, state), { contextMenu: null, selectedItems: [] })));
    }, []);
    return {
        handleContextMenu,
        handleContextMenuClose,
        contextMenuState: state.contextMenu
    };
}
exports.useFSContextMenu = useFSContextMenu;
//# sourceMappingURL=useFSContextMenu.js.map